export default __webpack_public_path__ + "static/media/check.149a0d1b.gif";